export enum ApplicationRoles {
    Default = 'Viguideplanning.Default',
    Admin = 'Viguideplanning.Admin',
    Developer = 'Viguideplanning.Developer',
    TestAccount = 'Viguideplanning.TestAccount',
    NevisDefault = 'NEVIS-Viguideplanning.Default',
    HeatLoadByIOT = 'CUAR_Viguideplanning-HeatLoadByIoT',
    QuoteAssistDefault = 'Quoteassist.Default'
}
